import * as React from 'react';

import { useSaveSearchContext } from '../../../../../packages/SaveSearchModal';

const SAVE_SEARCH_BUTTON_CLICKED_EVENT = 'saveSearchButton:clicked';

/**
 * Хук подписки на событие нажатия кнопки "Сохранить поиск" из микрофронтенда фильтров.
 * Кнопка живёт внутри мкф и не имеет доступа к React Context модалки,
 * поэтому общается через CustomEvent.
 */
export function useSaveSearchButtonEvent(): void {
  const { onOpen } = useSaveSearchContext();

  React.useEffect(() => {
    const handleSaveSearchClick = () => {
      onOpen();
    };

    window.addEventListener(SAVE_SEARCH_BUTTON_CLICKED_EVENT, handleSaveSearchClick);

    return () => {
      window.removeEventListener(SAVE_SEARCH_BUTTON_CLICKED_EVENT, handleSaveSearchClick);
    };
  }, [onOpen]);
}
